import { gql } from '@apollo/client';

export const orderSolarPanelsQuery = gql`
  mutation OrderSolarPanels($input: OrderSolarPanelsInput!) {
    orderSolarPanels(input: $input) {
      orderResult {
        orderId
      }
      errors {
        ... on GenericError {
          message
        }
        ... on Error {
          message
        }
        ... on IGraphQlErrorBase {
          __typename
          message
        }
        ... on ExpiredComparisionError {
          message
          expirationMoment
        }
      }
    }
  }
`;
